


// Fade in HTML5 Videos

let videoElems = document.getElementsByClassName('inline-video');
	
if (videoElems.length > 0) {
    inlineVideo();
}

function inlineVideo() {
    
    for(let i = 0; i < videoElems.length; i++){ //console.log(videoElems[i]);
        //console.log(videoElems[i]);
        //videoElems[i].pause();
        videoElems[i].addEventListener('canplay', function() {
            videoElems[i].classList.add('inline-video--ready');
            videoElems[i].play(); //console.log('canplay');
        });

        videoElems[i].addEventListener('pause', function() {
            videoElems[i].play(); //console.log('pause');
        });
                
        if (videoElems[i].readyState > 3) { 
            videoElems[i].classList.add('inline-video--ready');
            videoElems[i].play(); //console.log('ready state 3');
        }
        //videoElems[i].play();
    }
    
}
    
// function videoReady(){
//     this.classList.add('inline-video--ready');
//     this.play(); console.log(this);
// }


// Lazy load HTML5 Videos
document.addEventListener("DOMContentLoaded", function() {
var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy-video")); 

if ("IntersectionObserver" in window) {
var lazyVideoObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(video) { 
    if (video.isIntersecting) { 
      for (var source in video.target.children) {
        var videoSource = video.target.children[source];
        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
          videoSource.src = videoSource.dataset.src;
        }
      }
      video.target.load();
      video.target.classList.remove("lazy-video");
      lazyVideoObserver.unobserve(video.target);
    }
  });
}, {rootMargin: "0px 0px 500px 0px"});

lazyVideos.forEach(function(lazyVideo) {
  lazyVideoObserver.observe(lazyVideo);
});
}
});







/* ========================================================================== 
  VIDEO EMBED PLAY
  ========================================================================== */	

  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  
  var ytVideoEmbeds = document.getElementsByClassName('js-embed-youtube'); 
  var players = new Array();
  var YT;
//  var playerReady = false;

  function onYouTubeIframeAPIReady() { 
      for (var i = 0; i < ytVideoEmbeds.length; i++) {
          var curplayer = createPlayer(ytVideoEmbeds[i]);
           players[i] = curplayer;
      }
  }
  
  function createPlayer(videoWrapper) { 
      return new YT.Player(videoWrapper, {
          height: videoWrapper.height,
          width: videoWrapper.width,
          videoId: videoWrapper.dataset.src,
          playerVars: { 'autoplay': 0, 'controls': 1,'autohide':1,'origin':'window.location' }
      });
  }
  
//   function onPlayerReady(event) {
//       playerReady = true;
//   }
  
//   function onPlayerStateChange(event) {
//       if (event.data == YT.PlayerState.ENDED) {  }
//   }


    let vimeoPlayer,
        player, 
        videoEmbed,
        videoEmbedOverlay;

    $(document).on("click", '.js-play-embed', function(e) {
        e.preventDefault(); 
        //console.log(players);
        var videoType = $(this).data('type'); 
                
        if (videoType == 'vimeo') {
            videoEmbed = $(this).parent().parent().find('.js-embed-vimeo');
            vimeoPlayer = new Vimeo.Player(videoEmbed);
            vimeoPlayer.setVolume(1);
            vimeoPlayer.play();
        } else {
            videoEmbed = $(this).parent().parent().find('.js-embed-video'); 
            player = videoEmbed.data('player') - 1;
            players[player].playVideo();
            
        }
        

        videoEmbedOverlay = $(this).parent().parent().find('.js-embed-overlay'); 
        TweenMax.to(videoEmbedOverlay, 0.4, { autoAlpha:1 });

    });


    $(document).on("click", '.js-embed-close-overlay', function() {
          // Pause any Vimeo Players
        if (vimeoPlayer) {
            vimeoPlayer.pause();
        }
        
        // pause any YT players
        for (let i = 0; i < players.length; i++) {
            players[i].pauseVideo();
        }
        TweenMax.to($('.js-embed-overlay'), 0.4, { autoAlpha:0 });
    });
  
  
 
  


